import { createContext, JSX, Match, Switch, useContext } from "solid-js";
import c from "class-c";

import appIcon from "./assets/appIcon.svg";

import styles from "./Logo.module.scss";

declare namespace Logo {
  type Props = {
    class?: string;
    variant?: "icon" | "word" | "full";
    children?: JSX.Element;
  };
}

function Logo({ variant, class: className, children }: D<Logo.Props>) {
  const context = useContext(Logo.Context);

  return (
    <div class={c`${styles["logo"]} ${className}`}>
      <Switch>
        <Match when={variant === "icon"}>
          <img src={appIcon} />
        </Match>
        <Match when={variant === "word"}>
          <svg
            viewBox="0 1 96 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.85617 0.922363H0V29.4749H4.85617V0.922363Z"
              fill="currentColor"
            />
            <path
              d="M36.7156 0.922363H31.9023V29.4749H36.7156V0.922363Z"
              fill="currentColor"
            />
            <path
              d="M23.373 2.83506C23.373 1.28833 24.7043 0.00013746 26.3362 0.00013746C27.0908 -0.0072257 27.8181 0.281479 28.3618 0.804188C28.9056 1.3269 29.2223 2.04187 29.2439 2.7954C29.2655 3.54893 28.9903 4.28085 28.4774 4.8338C27.9646 5.38676 27.255 5.7166 26.5012 5.75241H26.3362C25.5591 5.75904 24.8109 5.45781 24.2556 4.91464C23.7002 4.37147 23.3829 3.63062 23.373 2.85426V2.83506ZM28.7039 29.4863H23.8816V8.02623H28.6926L28.7039 29.4863Z"
              fill="currentColor"
            />
            <path
              d="M70.796 18.6693C70.796 25.5381 66.4133 29.9999 60.0598 29.9999C53.7062 29.9999 49.3574 25.5381 49.3574 18.6693C49.3574 11.8004 53.696 7.50342 60.0598 7.50342C66.4235 7.50342 70.796 11.7936 70.796 18.6693ZM65.8144 18.6693C65.8144 14.6308 64.0514 11.2878 60.27 11.2878H59.8846C56.0614 11.2878 54.3842 14.7663 54.3842 18.6693C54.3842 22.6208 56.0614 26.2246 59.8846 26.2246H60.27C64.0943 26.2246 65.8144 22.7913 65.8144 18.6693Z"
              fill="currentColor"
            />
            <path
              d="M92.1465 4.6684H95.8872V0.922363H90.5688C87.1072 0.922363 85.5397 2.80329 85.5397 6.09207V7.99219H77.9679V6.46465C77.9673 5.98905 78.1557 5.53267 78.4919 5.19584C78.828 4.85901 79.2842 4.6693 79.7603 4.6684H83.5089V0.922363H78.1883C74.7255 0.922363 73.1592 2.80329 73.1592 6.09207V29.4771H77.9679V11.7518H85.5397V29.4771H90.3485V11.7518H95.8861V8.00348H90.3485V6.46465C90.3482 5.98914 90.5367 5.53294 90.8728 5.19617C91.2088 4.85941 91.6649 4.6696 92.1408 4.6684"
              fill="currentColor"
            />
            <path
              d="M4.85645 14.528L15.6085 29.4771H21.7101L10.6619 14.528L21.1665 0.922363H15.0378L4.85645 14.528Z"
              fill="currentColor"
            />
            <path
              d="M36.7129 18.2515L44.7956 29.4885H50.4869L42.168 18.2538L50.1422 8.02051H44.3706L36.7129 18.2515Z"
              fill="currentColor"
            />
          </svg>
        </Match>
        <Match when={variant === "full"}>
          <Switch>
            <Match when={context?.partner() === "guarantors"}>
              <svg
                viewBox="0 0 200 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <mask
                  id="mask0_148_1322"
                  style="mask-type:luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="57"
                  height="15"
                >
                  <path
                    d="M56.5486 0.0910645H0V14.1571H56.5486V0.0910645Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_148_1322)">
                  <path
                    d="M4.40147 13.9119H9.25713V7.21862L4.40147 13.9119ZM0 0.525269V13.9119L4.85568 7.21862L0 0.525269ZM4.40147 0.525269L9.25713 7.21862V0.525269H4.40147Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.1403 0.525269H12.9341V13.9119H15.1403V0.525269Z"
                    fill="currentColor"
                  />
                  <path
                    d="M29.6318 0.525269H27.4473V13.9119H29.6318V0.525269Z"
                    fill="currentColor"
                  />
                  <path
                    d="M23.5649 1.41638C23.5649 0.692475 24.1705 0.0910759 24.9167 0.0910759C25.2593 0.089629 25.5889 0.225419 25.8359 0.469734C26.0837 0.715138 26.2276 1.05131 26.2361 1.40524C26.2455 1.7586 26.1214 2.10193 25.8901 2.36303C25.6551 2.61978 25.3343 2.77504 24.9925 2.79737H24.9167C24.5623 2.80018 24.2208 2.66031 23.9651 2.40758C23.7116 2.14336 23.5681 1.7878 23.5649 1.41638ZM25.9873 13.9121H23.7921V3.85539H25.9766L25.9873 13.9121Z"
                    fill="currentColor"
                  />
                  <path
                    d="M45.1389 8.84489C45.1389 12.0635 43.1491 14.1572 40.2508 14.1572C37.3525 14.1572 35.3843 12.0635 35.3843 8.84489C35.3843 5.62627 37.3525 3.61047 40.2508 3.61047C43.1491 3.61047 45.1389 5.62627 45.1389 8.84489ZM42.8679 8.84489C42.8679 6.95157 42.0676 5.38126 40.3481 5.38126H40.1751C38.4339 5.38126 37.677 7.00726 37.677 8.84489C37.677 10.6825 38.4448 12.3864 40.1751 12.3864H40.3481C42.0892 12.3864 42.8679 10.7827 42.8679 8.84489Z"
                    fill="currentColor"
                  />
                  <path
                    d="M54.8508 2.28492H56.5486V0.525269H54.1262C52.5473 0.525269 51.8336 1.40509 51.8336 2.95314V3.8441H48.3946V3.13133C48.3949 2.90989 48.4804 2.69761 48.6324 2.54102C48.7845 2.38445 48.9906 2.29635 49.2057 2.29606H50.9143V0.525269H48.4919C46.913 0.525269 46.1992 1.40509 46.1992 2.95314V13.9231H48.3837V5.60375H51.8227V13.9119H54.0072V5.60375H56.527V3.8441H54.0072V3.1202C54.0073 3.01053 54.0283 2.90195 54.0692 2.80066C54.1099 2.69938 54.1698 2.60739 54.2452 2.52993C54.4107 2.37405 54.6264 2.28678 54.8508 2.28492Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.1406 6.90678L20.0287 13.9119H22.808L17.7793 6.90678L22.5593 0.525269H19.7692L15.1406 6.90678Z"
                    fill="currentColor"
                  />
                  <path
                    d="M29.6318 8.64429L33.3087 13.9121H35.8934L32.1083 8.64429L35.7311 3.84424H33.1032L29.6318 8.64429Z"
                    fill="currentColor"
                  />
                </g>
                <g clip-path="url(#clip0_148_1322)">
                  <path
                    d="M66.6968 1.36292L79.3426 14.0087"
                    stroke="black"
                    stroke-width="0.970685"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M79.3426 1.36292L66.6968 14.0087"
                    stroke="black"
                    stroke-width="0.970685"
                    stroke-miterlimit="10"
                  />
                </g>
                <svg
                  x="89.4912"
                  y="0"
                  width="109.801"
                  height="14.1571"
                  viewBox="0 0 192 25"
                >
                  <g fill="currentColor">
                    <path d="M0 22.086c0-.523.098-1.178.264-1.93L2.726 9.62H.264l.164-.72C2.89 8.082 4.5 6.707 5.845 4.32h.887L5.78 8.345h3.578l-.56 1.275H5.483L2.953 20.45c-.097.558-.163.95-.163 1.244 0 .589.263.883.754.883.821 0 1.938-.817 3.35-2.421l.559.392c-2.101 2.976-3.777 3.86-5.386 3.86-1.38 0-2.07-.787-2.07-2.325z" />
                    <path d="M23.316 20.842c-1.84 2.716-3.088 3.566-4.532 3.566-1.314 0-1.937-.786-1.937-2.193 0-.492.098-1.08.264-1.767l2.003-7.656c.264-1.047.393-1.735.393-2.093 0-.687-.295-.981-1.05-.981-1.905-.066-6.14 4.057-7.817 11.877l-.59 2.518H7.29L11.89 4.352c.097-.492.163-.818.163-1.047 0-.786-.427-1.08-1.707-1.31l.132-.556L15.4 0h.23l-3.45 14.921h.133c2.2-4.58 5.156-7.001 7.552-7.001q2.364 0 2.365 2.453c0 .589-.132 1.44-.393 2.519l-1.972 7.559c-.197.817-.295 1.375-.295 1.603 0 .458.163.687.525.687.657 0 1.478-.72 2.66-2.29z" />
                    <path d="m34.154 19.404.59.392c-1.97 3.436-4.27 4.68-6.37 4.68-3.12 0-5.122-2.519-5.122-6.184-.098-4.712 4.106-10.536 8.474-10.338 2.1 0 3.744 1.243 3.744 2.976.066 3.6-5.188 5.3-9.36 5.595-.032.557-.066.98-.066 1.21 0 3.239 1.412 4.777 3.383 4.777 1.61 0 3.185-1.047 4.73-3.108zm-7.915-3.697c1.906-.197 3.515-.72 4.827-1.538 1.28-.818 1.937-1.93 1.937-3.336 0-1.21-.56-1.899-1.575-1.899-2.365 0-4.532 3.305-5.189 6.773M76.608 24.114h-3.022v-3.688c-.635 2.325-2.474 4.08-5.748 4.08-3.493 0-5.943-1.899-5.943-6.25V7.754h3.283v10.263c0 2.453 1.236 3.872 3.755 3.872 2.135 0 3.241-1.231 3.766-2.344.472-.993.623-2.716.623-4.592V7.754h3.283v16.36zM90.807 24.113v-2.89c-1.129 1.985-2.67 3.217-5.726 3.217-4.345 0-6.163-2.356-6.163-5.313 0-2.607 1.468-5.116 6.955-5.116h4.387v-.927c0-2.171-1.129-3.261-3.305-3.261-1.402 0-3.283.316-3.909 2.944h-3.502c.415-3.076 2.89-5.344 7.367-5.344 3.622 0 6.634 1.636 6.634 6.118v10.57H90.81zm-.547-7.919h-3.572c-3.334 0-4.267 1.288-4.267 2.891 0 1.232.897 2.977 3.405 2.977 2.638 0 4.434-1.908 4.434-3.894z" />
                    <path d="M103.555 11.066c-2.069 0-3.366 1.594-3.366 1.594v11.42h-3.283V7.753h3.283v2.628c.946-2.105 2.773-2.957 5.594-2.957v3.945c-1.045-.326-1.646-.306-2.228-.306z" />
                    <path d="M118.194 24.113v-2.89c-1.128 1.985-2.67 3.217-5.725 3.217-4.346 0-6.163-2.356-6.163-5.313 0-2.607 1.468-5.116 6.954-5.116h4.387v-.927c0-2.171-1.128-3.261-3.305-3.261-1.402 0-3.283.316-3.908 2.944h-3.503c.415-3.076 2.89-5.344 7.367-5.344 3.623 0 6.635 1.636 6.635 6.118v10.57h-2.736zm-.547-7.919h-3.571c-3.334 0-4.267 1.288-4.267 2.891 0 1.232.896 2.977 3.405 2.977 2.638 0 4.433-1.908 4.433-3.894z" />
                    <path d="M138.945 24.113h-3.278v-8.856c0-3.38-.941-5.432-3.887-5.432-3.471 0-4.531 2.682-4.531 5.454v8.802h-3.283V7.754h3.283v3.468c.909-2.738 2.792-3.797 5.289-3.797 3.163 0 6.414 1.714 6.412 7.571v9.117z" />
                    <path d="M142.716 7.754V1.21h3.283v6.544h3.437v2.619h-3.437v8.615c0 1.282.066 2.512 1.793 2.512h1.644v2.616h-3.175c-3.185 0-3.545-2.283-3.545-4.45V10.37h-2.298V7.752h2.298z" />
                    <path d="M158.523 24.44c-5.999 0-8.244-4.418-8.244-8.65 0-3.775 1.817-8.365 8.024-8.365s8.232 4.308 8.232 8.552c0 3.807-1.805 8.465-8.012 8.465zm-.054-14.615c-3.798 0-4.685 3.436-4.685 5.911 0 2.28.887 6.304 4.795 6.304s4.456-4.035 4.456-6.087c0-2.334-.547-6.13-4.566-6.13z" />
                    <path d="M175.18 11.066c-2.069 0-3.366 1.594-3.366 1.594v11.42h-3.283V7.753h3.283v2.628c.945-2.105 2.772-2.957 5.594-2.957v3.945c-1.046-.326-1.647-.306-2.228-.306z" />
                    <path d="M177.737 18.55h3.503c.208 2.334 1.664 3.49 3.886 3.49 1.915 0 3.142-.893 3.142-2.32 0-1.759-1.698-1.822-4.422-2.696-3.251-1.046-5.43-2.475-5.43-5.103 0-2.901 3.088-4.483 6.449-4.483 2.628 0 6.94.883 7.138 5.92H188.5c-.044-2.333-1.434-3.523-3.557-3.523-1.336 0-3.021.513-3.021 2.027 0 1.178 1.028 2.003 3.7 2.826 3.33 1.073 6.153 1.603 6.153 4.835 0 2.965-2.713 4.917-6.448 4.917-3.471 0-7.477-1.2-7.587-5.89z" />
                    <path d="M49.078 15.916h5.301c-.83 3.383-3.12 5.496-5.975 5.496-4.077 0-7.692-3.15-7.692-9.003s3.71-8.807 7.531-8.807c3.268 0 5.567 1.67 6.344 5.335h4.206C57.757 4.113 53.583.769 48.47.769c-6.698 0-11.327 5.016-11.327 12.057 0 7.04 4.563 11.672 10.099 11.672 3.979 0 7.648-2.395 8.466-7.107v6.778h3.087V13.147h-9.714v2.77z" />
                  </g>
                </svg>
                <defs>
                  <clipPath id="clip0_148_1322">
                    <rect
                      width="12.9425"
                      height="12.9425"
                      fill="white"
                      transform="translate(66.5488 1.2146)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </Match>
            <Match when={true}>
              <svg
                viewBox="0 0 57 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_2006_7416"
                  style="mask-type:luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="57"
                  height="15"
                >
                  <path d="M56.5486 0H0V14.0661H56.5486V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_2006_7416)">
                  <path
                    d="M4.40147 13.8209H9.25713V7.12755L4.40147 13.8209ZM0 0.434204V13.8209L4.85568 7.12755L0 0.434204ZM4.40147 0.434204L9.25713 7.12755V0.434204H4.40147Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.1403 0.434204H12.9341V13.8209H15.1403V0.434204Z"
                    fill="currentColor"
                  />
                  <path
                    d="M29.6318 0.434204H27.4473V13.8209H29.6318V0.434204Z"
                    fill="currentColor"
                  />
                  <path
                    d="M23.5649 1.32532C23.5649 0.60141 24.1705 1.14445e-05 24.9167 1.14445e-05C25.2593 -0.00143541 25.5889 0.134355 25.8359 0.37867C26.0837 0.624074 26.2276 0.960244 26.2361 1.31418C26.2455 1.66754 26.1214 2.01087 25.8901 2.27196C25.6551 2.52871 25.3343 2.68397 24.9925 2.7063H24.9167C24.5623 2.70912 24.2208 2.56925 23.9651 2.31651C23.7116 2.05229 23.5681 1.69673 23.5649 1.32532ZM25.9873 13.821H23.7921V3.76433H25.9766L25.9873 13.821Z"
                    fill="currentColor"
                  />
                  <path
                    d="M45.1389 8.75382C45.1389 11.9724 43.1491 14.0662 40.2508 14.0662C37.3525 14.0662 35.3843 11.9724 35.3843 8.75382C35.3843 5.53521 37.3525 3.51941 40.2508 3.51941C43.1491 3.51941 45.1389 5.53521 45.1389 8.75382ZM42.8679 8.75382C42.8679 6.86051 42.0676 5.29019 40.3481 5.29019H40.1751C38.4339 5.29019 37.677 6.9162 37.677 8.75382C37.677 10.5914 38.4448 12.2953 40.1751 12.2953H40.3481C42.0892 12.2953 42.8679 10.6917 42.8679 8.75382Z"
                    fill="currentColor"
                  />
                  <path
                    d="M54.8508 2.19385H56.5486V0.434204H54.1262C52.5473 0.434204 51.8336 1.31403 51.8336 2.86207V3.75304H48.3946V3.04027C48.3949 2.81883 48.4804 2.60654 48.6324 2.44996C48.7845 2.29338 48.9906 2.20528 49.2057 2.20499H50.9143V0.434204H48.4919C46.913 0.434204 46.1992 1.31403 46.1992 2.86207V13.832H48.3837V5.51269H51.8227V13.8209H54.0072V5.51269H56.527V3.75304H54.0072V3.02913C54.0073 2.91947 54.0283 2.81089 54.0692 2.7096C54.1099 2.60832 54.1698 2.51632 54.2452 2.43887C54.4107 2.28299 54.6264 2.19571 54.8508 2.19385Z"
                    fill="currentColor"
                  />
                  <path
                    d="M15.1406 6.81571L20.0287 13.8209H22.808L17.7793 6.81571L22.5593 0.434204H19.7692L15.1406 6.81571Z"
                    fill="currentColor"
                  />
                  <path
                    d="M29.6318 8.55322L33.3087 13.821H35.8934L32.1083 8.55322L35.7311 3.75317H33.1032L29.6318 8.55322Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            </Match>
          </Switch>
        </Match>
      </Switch>
      {children}
    </div>
  );
}

export default Logo;

Logo.Context = createContext<{ partner: () => string | undefined }>();

declare namespace Logo.Provider {
  type Props = {
    partner?: string;
    children: JSX.Element;
  };
}
Logo.Provider = ({ partner, children }: D<Logo.Provider.Props>) => {
  return (
    <Logo.Context.Provider value={{ partner: () => partner }}>
      {children}
    </Logo.Context.Provider>
  );
};
